import _toConsumableArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { createContext as e, useRef as r, createElement as t, useContext as n, useReducer as o, useEffect as c, useLayoutEffect as u } from "react";
import { unstable_runWithPriority as s, unstable_NormalPriority as i } from "scheduler";
import { unstable_batchedUpdates as d } from "react-dom";

var p = Symbol(),
    a = Symbol(),
    f = "undefined" == typeof window || /ServerSideRendering/.test(window.navigator && window.navigator.userAgent) ? c : u,
    l = s ? function (e) {
  return s(i, e);
} : function (e) {
  return e();
},
    v = function v(e) {
  return e;
};

function w(n) {
  var o = e(_defineProperty({}, p, {
    v: {
      current: n
    },
    n: {
      current: -1
    },
    l: new Set(),
    u: function u(e) {
      return e();
    }
  }));
  var c;
  return o[a] = o.Provider, o.Provider = (c = o.Provider, function (_ref) {
    var e = _ref.value,
        n = _ref.children;
    var o = r(e),
        u = r(0),
        s = r();

    if (!s.current) {
      var _e2 = new Set(),
          _r = function _r(r) {
        d(function () {
          u.current += 1, _e2.forEach(function (e) {
            return e([u.current]);
          }), r();
        });
      };

      s.current = _defineProperty({}, p, {
        v: o,
        n: u,
        l: _e2,
        u: _r
      });
    }

    return f(function () {
      o.current = e, u.current += 1, l(function () {
        s.current[p].l.forEach(function (r) {
          r([u.current, e]);
        });
      });
    }, [e]), t(c, {
      value: s.current
    }, n);
  }), delete o.Consumer, o;
}

function E(e, r) {
  var t = n(e)[p];
  if ("object" == typeof process && "production" !== process.env.NODE_ENV && !t) throw new Error("useContextSelector requires special context");

  var c = t.v.current,
      u = t.n.current,
      s = t.l,
      i = r(c),
      _o = o(function (e, t) {
    if (!t) return [c, i];
    if (t[0] <= u) return Object.is(e[1], i) ? e : [c, i];

    try {
      if (2 === t.length) {
        if (Object.is(e[0], t[1])) return e;

        var _n = r(t[1]);

        return Object.is(e[1], _n) ? e : [t[1], _n];
      }
    } catch (e) {}

    return _toConsumableArray(e);
  }, [c, i]),
      _o2 = _slicedToArray(_o, 2),
      d = _o2[0],
      a = _o2[1];

  return Object.is(d[1], i) || a(), f(function () {
    return s.add(a), function () {
      s.delete(a);
    };
  }, [s]), d[1];
}

function h(e) {
  return E(e, v);
}

function b(e) {
  var r = n(e)[p];
  if ("object" == typeof process && "production" !== process.env.NODE_ENV && !r) throw new Error("useContextUpdate requires special context");
  var t = r.u;
  return t;
}

var m = function m(_ref2) {
  var e = _ref2.context,
      r = _ref2.value,
      n = _ref2.children;
  var o = e[a];
  if ("object" == typeof process && "production" !== process.env.NODE_ENV && !o) throw new Error("BridgeProvider requires special context");
  return t(o, {
    value: r
  }, n);
},
    x = function x(e) {
  var r = n(e);
  if ("object" == typeof process && "production" !== process.env.NODE_ENV && !r[p]) throw new Error("useBridgeValue requires special context");
  return r;
};

export { m as BridgeProvider, w as createContext, x as useBridgeValue, h as useContext, E as useContextSelector, b as useContextUpdate };